import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DrawerMenuComponent } from './drawer-menu/drawer-menu.component';
import { RelatorioEmailDialogComponent } from './relatorio-dialog/relatorio-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [DrawerMenuComponent, RelatorioEmailDialogComponent],
  imports: [
    CommonModule,
    MatSidenavModule,
    MatIconModule, 
    MatSnackBarModule, 
    MatProgressSpinnerModule, 
    MatDialogModule
  ],
  exports: [DrawerMenuComponent]
})
export class DrawerMenuModule { }
